import { createFileRoute, Link } from "@tanstack/react-router";
import { LegalPage, LegalSection } from "@/components/legal-page";

export const Route = createFileRoute("/termos")({
  head: () => ({
    meta: [
      { title: "Termos de Uso | H2J Growth Company" },
      {
        name: "description",
        content:
          "Condições de uso do site da H2J Growth Company: serviços, propriedade intelectual, responsabilidades e disposições gerais.",
      },
      { property: "og:title", content: "Termos de Uso | H2J Growth Company" },
      {
        property: "og:description",
        content:
          "Condições de uso do site da H2J Growth Company: serviços, propriedade intelectual, responsabilidades e disposições gerais.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: TermsOfUse,
});

function TermsOfUse() {
  return (
    <LegalPage title="Termos de Uso" updated="2 de outubro de 2026">
      <LegalSection title="1. Aceitação">
        <p>
          Estes Termos de Uso regulam o acesso e a utilização do site h2jcompany.com.br e de suas páginas
          complementares (inclusive as páginas de diagnóstico de crescimento, Construir AI e programa de
          embaixadores), operados pela <strong>H2J Growth Company</strong> ("H2J", "nós").
        </p>
        <p>
          Ao acessar ou utilizar o site, você declara ter lido, entendido e aceito integralmente estes Termos.
          Se não concordar com qualquer disposição, não utilize o site.
        </p>
      </LegalSection>

      <LegalSection title="2. Sobre o site e os serviços">
        <p>
          A H2J é uma consultoria de crescimento que conecta estratégia, marketing, aquisição, performance,
          tecnologia e processo comercial. Por meio deste site, a H2J apresenta seus serviços e recebe
          solicitações de contato, diagnóstico de crescimento e candidaturas ao programa de embaixadores.
        </p>
        <p>
          A H2J Growth Company é inscrita no CNPJ sob o nº <strong>57.193.844/0001-13</strong>, com endereço na
          Rua 1001, Balneário Camboriú, estado de Santa Catarina, Brasil.
        </p>
        <p>
          O preenchimento dos formulários do site não configura contratação de serviços. Após o envio, a
          equipe H2J avalia o seu cenário e entra em contato para, havendo aderência, evoluir a conversa
          comercial. A contratação de quaisquer serviços dependerá de proposta e aceite específicos.
        </p>
      </LegalSection>

      <LegalSection title="3. Uso permitido do site">
        <p>Ao utilizar o site, você se compromete a:</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>Fornecer informações verdadeiras, completas e atualizadas nos formulários, sendo você responsável pelos dados informados;</li>
          <li>Utilizar o site apenas para finalidades lícitas e relacionadas ao contato com a H2J;</li>
          <li>Não utilizar robôs, scripts ou meios automatizados para enviar formulários em massa, coletar dados ou sobrecarregar a infraestrutura;</li>
          <li>Não tentar acessar áreas restritas, contas de terceiros ou sistemas da H2J sem autorização;</li>
          <li>Não transmitir conteúdo ofensivo, discriminatório, ilegal ou que viole direitos de terceiros.</li>
        </ul>
        <p>
          A H2J pode suspender ou restringir o acesso de quem descumprir estes compromissos, sem prejuízo das
          medidas legais cabíveis.
        </p>
      </LegalSection>

      <LegalSection title="4. Propriedade intelectual">
        <p>
          Todo o conteúdo do site, incluindo marca, nome empresarial, logotipos, textos, estruturas,
          metodologias, materiais de apresentação, layout, códigos e demais elementos, é de titularidade da
          H2J ou de seus licenciantes e é protegido pela legislação brasileira de propriedade intelectual
          (Lei nº 9.279/96 e Lei nº 9.610/98).
        </p>
        <p>
          É permitido visualizar e compartilhar o conteúdo para fins informativos, citando a fonte. É vedada a
          reprodução total ou parcial para fins comerciais, a alteração e a apresentação do conteúdo como
          próprio, sem autorização prévia e por escrito da H2J.
        </p>
      </LegalSection>

      <LegalSection title="5. Informações, diagnósticos e resultados">
        <p>
          Os conteúdos do site têm caráter informativo e comercial. Análises, diagnósticos e recomendações
          produzidos pela H2J, inclusive o Diagnóstico de Crescimento, partem das informações fornecidas por
          você e da realidade da sua operação no momento da análise, e não constituem promessa de resultado,
          garantia de receita ou aconselhamento jurídico, contábil ou financeiro.
        </p>
        <p>
          Resultados de marketing e vendas dependem de fatores que extrapolam o trabalho da consultoria, como
          mercado, concorrência, produto, capacidade de atendimento e execução interna da própria empresa.
        </p>
      </LegalSection>

      <LegalSection title="6. Programa de embaixadores">
        <p>
          O cadastro no programa de embaixadores constitui uma candidatura, sujeita à análise e à aprovação
          prévias pela H2J. As condições de participação, remuneração ou crédito e as obrigações de cada
          embaixador serão formalizadas em instrumento próprio, que prevalecerá sobre estes Termos nessa
          matéria.
        </p>
      </LegalSection>

      <LegalSection title="7. Limitação de responsabilidade">
        <p>
          O site é fornecido no estado em que se encontra. A H2J envidará esforços razoáveis para mantê-lo
          disponível e atualizado, mas não garante disponibilidade ininterrupta, ausência de erros ou
          imunidade a interrupções técnicas.
        </p>
        <p>
          Na máxima extensão permitida pela lei, a H2J não responde por danos indiretos, lucros cessantes ou
          perda de dados decorrentes do uso do site, nem por informações falsas ou desatualizadas fornecidas
          pelos usuários nos formulários. Nada aqui limita responsabilidade que não possa ser excluída por
          lei, inclusive perante consumidores, nos termos do Código de Defesa do Consumidor.
        </p>
      </LegalSection>

      <LegalSection title="8. Links e serviços de terceiros">
        <p>
          O site contém links e integrações para serviços de terceiros, como WhatsApp e Instagram, que são
          operados sob condições próprias dessas plataformas. A H2J não controla esses serviços e não se
          responsabiliza por seus conteúdos ou práticas de privacidade. Recomendamos ler os termos de cada
          plataforma antes de utilizá-la.
        </p>
      </LegalSection>

      <LegalSection title="9. Dados pessoais">
        <p>
          O tratamento dos seus dados pessoais segue regras específicas, descritas em nossa{" "}
          <Link to="/privacidade">Política de Privacidade</Link>, que integra estes Termos.
        </p>
      </LegalSection>

      <LegalSection title="10. Alterações dos Termos">
        <p>
          A H2J pode alterar estes Termos a qualquer momento, publicando a versão atualizada nesta página com
          a nova data de atualização. O uso continuado do site após a publicação implica a aceitação da versão
          vigente.
        </p>
      </LegalSection>

      <LegalSection title="11. Legislação e foro">
        <p>
          Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro do
          domicílio do usuário para dirimir controvérsias relacionadas ao site, quando se tratar de relação de
          consumo; nas demais hipóteses, o foro competente para dirimir qualquer controvérsia é o da comarca
          de Joinville, estado de Santa Catarina, com renúncia a qualquer outro, por mais privilegiado que
          seja, salvo previsão diversa em contrato de prestação de serviços firmado com a H2J.
        </p>
        <p>Antes de acionar o Judiciário, incentive-se a solução amigável por meio dos canais de contato abaixo.</p>
      </LegalSection>

      <LegalSection title="12. Contato">
        <p>
          Dúvidas sobre estes Termos podem ser enviadas para{" "}
          <a href="mailto:contato@h2jcompany.com.br">contato@h2jcompany.com.br</a>, para o WhatsApp +55 (11)
          97148-8408 ou pelo Instagram @h2jcompany.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
